import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 17V9" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 17V5" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 17v-3" })
	]
});
const ForwardRef = forwardRef(SvgChart);
export default ForwardRef;
